import React from 'react'
import { Link } from 'react-router-dom'

function Gallery() {
  return (
    <div>
    <div className="subheader normal-bg section-padding">
      <div className="container">
        <div className="row">
          <div className="col-12 text-left">
            <h1 className="text-custom-white">Gallery</h1>
            <ul className="custom-flex">
              <li className="fw-500"> <Link to="/" className="text-custom-white">Home</Link> </li>
              <li className="active fw-500"> Gallery </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    {/* <!-- End Subheader --> 
    <!-- Start gallery --> */}
    <section className="section-padding gallery">
      <div className="container">
        <div className="section-header text-center">
          <div className="section-heading">
            <h3 className="text-custom-black">Our <span className="text-custom-blue">Gallry</span></h3>
            <div className="section-description">
              <p className="text-light-dark">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text.</p>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <div className="tabs filter-gallery">
              <ul className="custom-flex nav nav-tabs mb-xl-40">
                <li className="nav-item"> <Link className="nav-link active" to="#" data-filter="*">Show All</Link> </li>
                <li className="nav-item"> <Link className="nav-link" to="#" data-filter=".tab-gallery">Brakes</Link> </li>
                <li className="nav-item"> <Link className="nav-link" to="#" data-filter=".tab-gallery-1">Suspension</Link> </li>
                <li className="nav-item"> <Link className="nav-link" to="#" data-filter=".tab-gallery-2">Wheels</Link> </li>
                <li className="nav-item"> <Link className="nav-link" to="#" data-filter=".car-gallery">Steering</Link> </li>
              </ul>
            </div>
            <div className="row gallery-grid">
              <div className="col-lg-4 col-md-6 filter-box tab-gallery">
                <div className="gallery-item mb-xl-30"> <Link to="#" className="popup"> <img src="/tm/react/bycycle/assets/images/gallery/g-1.jpg" className="image-fit" alt="img"/> </Link> </div>
              </div>
              <div className="col-lg-4 col-md-6 filter-box tab-gallery-1">
                <div className="gallery-item mb-xl-30"> <Link to="#" className="popup"> <img src="/tm/react/bycycle/assets/images/gallery/g-2.jpg" className="image-fit" alt="img"/> </Link> </div>
              </div>
              <div className="col-lg-4 col-md-6 filter-box tab-gallery-2">
                <div className="gallery-item mb-xl-30"> <Link to="#" className="popup"> <img src="/tm/react/bycycle/assets/images/gallery/g-3.jpg" className="image-fit" alt="img"/> </Link> </div>
              </div>
              <div className="col-lg-4 col-md-6 filter-box car-gallery">
                <div className="gallery-item mb-xl-30"> <Link to="#" className="popup"> <img src="/tm/react/bycycle/assets/images/gallery/g-4.jpg" className="image-fit" alt="img"/> </Link> </div>
              </div>
              <div className="col-lg-4 col-md-6 filter-box tab-gallery">
                <div className="gallery-item mb-xl-30"> <Link to="#" className="popup"> <img src="/tm/react/bycycle/assets/images/gallery/g-5.jpg" className="image-fit" alt="img"/> </Link> </div>
              </div>
              <div className="col-lg-4 col-md-6 filter-box tab-gallery-1">
                <div className="gallery-item mb-xl-30"> <Link to="#" className="popup"> <img src="/tm/react/bycycle/assets/images/gallery/g-6.jpg" className="image-fit" alt="img"/> </Link> </div>
              </div>
              <div className="col-lg-4 col-md-6 filter-box tab-gallery-2">
                <div className="gallery-item mb-xl-30"> <Link to="#" className="popup"> <img src="/tm/react/bycycle/assets/images/gallery/g-7.jpg" className="image-fit" alt="img"/> </Link> </div>
              </div>
              <div className="col-lg-4 col-md-6 filter-box car-gallery">
                <div className="gallery-item mb-xl-30"> <Link to="#" className="popup"> <img src="/tm/react/bycycle/assets/images/gallery/g-8.jpg" className="image-fit" alt="img"/> </Link> </div>
              </div>
              <div className="col-lg-4 col-md-6 filter-box tab-gallery">
                <div className="gallery-item mb-xl-30"> <Link to="#" className="popup"> <img src="/tm/react/bycycle/assets/images/gallery/g-9.jpg" className="image-fit" alt="img"/> </Link> </div>
              </div>
              <div className="col-lg-4 col-md-6 filter-box tab-gallery-1">
                <div className="gallery-item mb-xl-30"> <Link to="#g" className="popup"> <img src="/tm/react/bycycle/assets/images/gallery/g-10.jpg" className="image-fit" alt="img"/> </Link> </div>
              </div>
              <div className="col-lg-4 col-md-6 filter-box tab-gallery-2">
                <div className="gallery-item mb-xl-30"> <Link to="#g" className="popup"> <img src="/tm/react/bycycle/assets/images/gallery/g-11.jpg" className="image-fit" alt="img"/> </Link> </div>
              </div>
              <div className="col-lg-4 col-md-6 filter-box car-gallery">
                <div className="gallery-item mb-xl-30"> <Link to="#g" className="popup"> <img src="/tm/react/bycycle/assets/images/gallery/g-12.jpg" className="image-fit" alt="img"/> </Link> </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    </div>
  )
}

export default Gallery